import { i18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { toast } from 'sonner';

import { presentableErrorMessage } from '@/lib/http/api-error';

export const mutationErrorMessage = (error: unknown): string =>
	presentableErrorMessage(error) ?? i18n._(msg`Something went wrong. Try again in a moment.`);

export const handleMutationError = (error: unknown) => {
	const message = mutationErrorMessage(error);
	toast.error(message, { id: message });
};

export const onMutationError = handleMutationError;
